{
  "greeting": {
    "salam": "السلام علیکم",
    "salamWithName": "السلام علیکم، {{name}}"
  },
  "dock": {
    "saved": "محفوظ شدہ",
    "savedVerses": "محفوظ آیات",
    "tasks": "کام",
    "notes": "نوٹس"
  },
  "actions": {
    "save": "محفوظ کریں",
    "cancel": "منسوخ کریں",
    "close": "بند کریں",
    "delete": "حذف کریں",
    "rename": "نام بدلیں",
    "dismiss": "ہٹا دیں",
    "loading": "لوڈ ہو رہا ہے…",
    "reload": "دوبارہ لوڈ کریں",
    "retry": "دوبارہ کوشش کریں",
    "expand": "پھیلائیں",
    "collapse": "سمیٹیں"
  },
  "nav": {
    "appNavigation_aria": "ایپ نیویگیشن"
  },
  "tabs": {
    "home": "ہوم",
    "tasks": "کام",
    "notes": "نوٹس",
    "more": "مزید"
  },
  "more": {
    "daily": "روزانہ",
    "account": "اکاؤنٹ",
    "savedVerses": "محفوظ آیات",
    "qibla": "قبلہ",
    "prayerTimes": "نماز کے اوقات اور یاد دہانیاں",
    "rhemnPro": "Rhemn Pro",
    "proManagedViaAccount": "آپ کے Rhemn اکاؤنٹ کے ذریعے منظم کیا جاتا ہے",
    "upgrade": "اپ گریڈ",
    "privacyPolicy": "رازداری کی پالیسی",
    "version": "Rhemn · v{{version}}",
    "back_aria": "واپس",
    "deleteAccount": "اکاؤنٹ حذف کریں"
  },
  "reflection": {
    "dismiss_aria": "تدبر ہٹا دیں"
  },
  "app": {
    "loading_aria": "Rhemn لوڈ ہو رہا ہے",
    "logo_alt": "Rhemn",
    "safariManageOnWeb": "اپنی Rhemn Pro سبسکرپشن ویب پر منظم کریں۔ جب آپ اپنے سبسکرائب شدہ اکاؤنٹ سے سائن اِن کریں گے تو Pro یہاں خود بخود کھل جائے گا۔"
  },
  "header": {
    "qiblaDirection_aria": "قبلہ کی سمت",
    "prayerTimes_aria": "نماز کے اوقات",
    "prayerTimesTitle": "نماز کے اوقات",
    "method": "طریقہ",
    "methodHelp": "طریقہ شمار شدہ اوقات پر اثر ڈالتا ہے"
  },
  "search": {
    "search_aria": "تلاش کریں",
    "searchLabel": "تلاش کریں",
    "searchWeb_placeholder": "ویب پر تلاش کریں"
  },
  "focus": {
    "input_placeholder": "آج سب سے اہم کیا ہے؟",
    "example_worship": "نماز خشوع کے ساتھ، بغیر جلدی کے",
    "example_kindness": "امی کو فون کرنا، صرف ان کی بات سننے کے لیے",
    "example_reflect": "آج کی آیت کے ساتھ اپنی نیت پر غور کرنا",
    "saveIntention_aria": "نیت محفوظ کریں",
    "celebration": "🤲 ماشاءاللہ"
  },
  "profile": {
    "profileFallback": "پروفائل",
    "profileAndAccount_aria": "پروفائل اور اکاؤنٹ",
    "profileDialog_aria": "پروفائل",
    "editName_aria": "اپنا نام تبدیل کریں",
    "logo_alt": "Rehmn",
    "proBadge": "PRO",
    "manageSubscription": "سبسکرپشن منظم کریں",
    "manageSubscription_aria": "اپنی Rehmn Pro سبسکرپشن منظم کریں",
    "anonymousAnalytics": "گمنام تجزیات",
    "anonymousAnalyticsNote": "صرف مجموعی — کبھی آپ سے منسلک نہیں",
    "shareAnalytics_aria": "گمنام استعمال کے تجزیات شیئر کریں",
    "signOut": "سائن آؤٹ",
    "signingOut": "سائن آؤٹ ہو رہا ہے…",
    "signOut_aria": "Rehmn سے سائن آؤٹ کریں",
    "restorePurchases": "Restore purchases",
    "restorePurchases_aria": "Restore previous purchases"
  },
  "background": {
    "loading": "پس منظر لوڈ ہو رہا ہے...",
    "fallbackNotice": "متبادل تصویر استعمال ہو رہی ہے (Unsplash API دستیاب نہیں)",
    "noImage": "کوئی پس منظر تصویر دستیاب نہیں",
    "error": "خرابی: {{message}}",
    "photoByOnUnsplash": "تصویر بشکریہ <photographer>{{name}}</photographer> پر <unsplash>Unsplash</unsplash>"
  },
  "error": {
    "title": "کچھ غلط ہو گیا",
    "fallbackMessage": "ایک غیر متوقع خرابی پیش آئی۔"
  },
  "theme": {
    "switchToLight_title": "روشن موڈ پر جائیں",
    "switchToDark_title": "تاریک موڈ پر جائیں"
  },
  "upgradeCta": {
    "upgradeToPro": "Pro میں اپ گریڈ کریں",
    "restorePurchases": "Restore purchases",
    "restoring": "Restoring…",
    "restoreEmpty": "No purchases found.",
    "pricePerMonth": "{{price}} / ماہ",
    "pricePerYear": "{{price}} / سال",
    "purchasePending": "منظوری کا انتظار ہے۔ خریداری منظور ہوتے ہی Pro خود بخود فعال ہو جائے گا۔",
    "storeUnavailable": "اس وقت App Store تک رسائی ممکن نہیں۔ تھوڑی دیر بعد دوبارہ کوشش کریں۔",
    "purchaseFailed": "خریداری مکمل نہیں ہو سکی۔ تھوڑی دیر بعد دوبارہ کوشش کریں۔"
  },
  "upgradeCard": {
    "eyebrow": "Rhemn Pro · پہلے سال 25% رعایت",
    "title": "آپ کی نمازوں کے درمیان کے اوقات کے لیے۔",
    "body": "صوتی نوٹس جو تحریر، خلاصہ اور کاموں میں بدل جاتے ہیں۔ آپ کے اوقاتِ نماز کے گرد بنا دن کا منصوبہ۔ AI کے ساتھ نوٹس۔",
    "price": "$29.99",
    "period": "آپ کے پہلے سال کے لیے",
    "priceIos": "پہلے سال 25% رعایت",
    "terms": "اس کے بعد $39.99 سالانہ۔ کوڈ {{code}} آپ کے لیے لاگو کر دیا گیا ہے۔",
    "termsIos": "عام سالانہ قیمت پر تجدید ہوتی ہے۔ App Store میں کوڈ {{code}} استعمال کریں۔",
    "free": "اوقاتِ نماز، قبلہ، روزانہ آیت اور کام مفت رہیں گے۔",
    "cta": "Pro میں اپ گریڈ کریں",
    "dismiss": "ابھی نہیں"
  },
  "planChooser": {
    "monthly": "ماہانہ",
    "yearly": "سالانہ",
    "yearlyValue": "چار مہینے ہماری طرف سے۔",
    "freeNote": "نماز کے اوقات، قبلہ، روزانہ کی آیت اور کام مفت ہیں۔ Rhemn Pro مزید دیتا ہے:",
    "includes_planner": "پانچ نمازوں کے گرد ترتیب دیا گیا دن کا منصوبہ، اور ”میرا دن ترتیب دیں“",
    "includes_insights": "Quran Insights — کسی بھی آیت کے بارے میں سوال کریں اور اس کا پس منظر پڑھیں",
    "includes_reflections": "آپ کی مقرر کردہ نیت کے مطابق لکھے گئے روزانہ آیت کے تدبرات",
    "includes_notes": "نوٹس اور صوتی نوٹس، AI خلاصے اور درستگی کے ساتھ",
    "includes_extras": "محفوظ آیات، آیت کارڈز، سلسلہ، اور 5 دن کی پیش گوئی",
    "renewsMonthly": "منسوخ کرنے تک ہر ماہ تجدید ہوتی ہے",
    "renewsYearly": "منسوخ کرنے تک ہر 12 ماہ بعد تجدید ہوتی ہے",
    "continue": "جاری رکھیں",
    "renewalTerms": "تصدیق پر رقم آپ کے Apple ID سے وصول کی جائے گی۔ مدت ختم ہونے سے کم از کم 24 گھنٹے قبل خودکار تجدید بند نہ کی جائے تو سبسکرپشن خودکار طور پر تجدید ہو جاتی ہے۔ Apple ID کی ترتیبات میں کسی بھی وقت انتظام یا منسوخ کریں۔",
    "retry": "دوبارہ کوشش کریں"
  },
  "streak": {
    "badge_aria": "روزانہ تسلسل — {{count}} دن",
    "title": "روزانہ تسلسل",
    "daysWithCount": "{{count}} دن کا تسلسل",
    "start": "آج ہی آغاز کریں — آیت کے ساتھ ایک لمحہ گزاریں یا نماز نشان زد کریں۔",
    "prayedToday": "آج نماز پڑھی",
    "readVerse": "آج کی آیت پڑھی",
    "autoHint": "جب آپ آیت کے ساتھ ایک لمحہ گزارتے ہیں تو وہ خود بخود نشان زد ہو جاتی ہے۔",
    "milestoneTitle": "نیت کے {{count}} دن",
    "milestoneBody": "الحمد للہ۔ یہ سنگِ میل شیئر کریں — شاید آپ کا کوئی پیارا بھی آغاز کرے۔",
    "share": "شیئر کریں",
    "dismiss": "ابھی نہیں",
    "cardLabel": "نیت کے دن",
    "shareCaption": "نیت کے ساتھ آغاز کے {{count}} دن — rhemn.com",
    "imageSaved": "تصویر محفوظ ہو گئی۔",
    "couldNotCreateImage": "تصویر نہیں بن سکی۔ براہ کرم دوبارہ کوشش کریں۔"
  },
  "qibla": {
    "compassIcon_aria": "قطب نما آئیکن",
    "title": "قبلہ کی سمت",
    "locationUnavailable": "مقام دستیاب نہیں",
    "locating": "مقام تلاش ہو رہا ہے…",
    "compass_aria": "قبلہ قطب نما",
    "directionN": "ش",
    "directionE": "م",
    "directionS": "ج",
    "directionW": "مغ",
    "facingQibla": "قبلہ رو",
    "enableLiveCompass": "لائیو قطب نما فعال کریں",
    "enableLiveCompassNote": "موشن سینسر استعمال کرتا ہے تاکہ جب آپ مڑیں تو تیر بھی ساتھ مڑے — مقام نہیں",
    "directionToMecca": "مکہ کی سمت",
    "enableLocation": "سمت کا حساب لگانے کے لیے مقام تک رسائی فعال کریں",
    "hintLive": "تیر آپ کے آلے کے رخ کو حقیقی وقت میں ٹریک کرتا ہے",
    "hintStatic": "شمال سے زاویہ — درست سمت کے لیے قطب نما کے ساتھ استعمال کریں",
    "live": "لائیو",
    "footerVerse": "\"آپ اپنا منھ مسجد حرام کی طرف پھیر لیں\" – قرآن 2:144"
  },
  "legal": {
    "links_aria": "قانونی",
    "termsOfUse": "استعمال کی شرائط",
    "privacyPolicy": "رازداری کی پالیسی"
  },
  "auth": {
    "signInForPro": "پہلے سائن ان کریں — آپ کا Pro ہر جگہ آپ کے ساتھ جاتا ہے۔"
  },
  "integrations": {
    "row": {
      "label": "کیلنڈرز اور کام",
      "caption": "منسلک",
      "subNone": "منسلک نہیں",
      "subFree": "Google Calendar، Google Tasks اور مزید",
      "subAttention": "{{provider}} کو توجہ درکار ہے",
      "subPaused": "مطابقت رکی ہوئی ہے"
    },
    "list": {
      "title": "کیلنڈرز اور کام",
      "subtitle": "اپنی میٹنگز اور کاموں کو اپنے دن میں شامل کریں۔",
      "footnote": "Rhemn صرف وہی پڑھتا ہے جس کی ضرورت ہو، اور آپ کے ایونٹس کبھی محفوظ نہیں کرتا۔",
      "privacy": "رازداری کی پالیسی",
      "connect": "جوڑیں",
      "connect_aria": "{{what}} جوڑیں",
      "checking": "جانچا جا رہا ہے…",
      "loadError": "آپ کے کنکشنز لوڈ نہیں ہو سکے۔",
      "tryAgain": "دوبارہ کوشش کریں",
      "offline": "آپ آف لائن ہیں۔ دوبارہ آن لائن آنے پر جوڑیں۔",
      "unavailable": "کیلنڈرز اور کام فی الحال دستیاب نہیں ہیں۔",
      "disconnected": "{{provider}} منقطع ہو گیا۔",
      "google": {
        "name": "Google",
        "sub": "کیلنڈر اور کام",
        "what": "Google Calendar اور Tasks"
      },
      "todoist": {
        "name": "Todoist",
        "sub": "کام اور منصوبے",
        "what": "Todoist"
      },
      "apple": {
        "name": "کیلنڈر اور یاد دہانیاں",
        "subNative": "اس {{device}} پر",
        "subSafari": "iPhone اور Mac کے لیے Rhemn ایپ میں"
      },
      "synced": "{{when}} مطابقت پذیر ہوا",
      "connectedSub": "منسلک",
      "syncing": "مطابقت پذیر ہو رہا ہے…",
      "reconnectSub": "مطابقت جاری رکھنے کے لیے دوبارہ جوڑیں",
      "errorSub": "آخری مطابقت مکمل نہیں ہوئی",
      "pausedSub": "رکا ہوا · Rhemn Pro ختم ہو گیا"
    },
    "explainer": {
      "google": {
        "title": "Google Calendar اور Tasks جوڑیں",
        "p1Lead": "آپ کا کیلنڈر، صرف پڑھنے کے لیے",
        "p1Body": "Rhemn آپ کے ایونٹس آپ کے دن میں دکھاتا ہے اور جانتا ہے کہ آپ کب مصروف ہیں۔ یہ انہیں محفوظ نہیں کرتا۔",
        "p2Lead": "Google Tasks، دونوں طرف",
        "p2Body": "آپ کی چنی گئی فہرستیں مطابقت میں رہتی ہیں، تاکہ آپ کہیں بھی کام مکمل نشان زد کر سکیں۔",
        "p3Lead": "واپس لینا آپ کے اختیار میں",
        "p3Body": "کسی بھی وقت منقطع کریں، یہاں سے یا اپنے Google اکاؤنٹ سے۔",
        "footnote": "Google آپ کو بالکل بتائے گا کہ Rhemn کیا مانگ رہا ہے۔"
      },
      "todoist": {
        "title": "Todoist جوڑیں",
        "p1Lead": "آپ کے منصوبے، دونوں طرف",
        "p1Body": "آپ کے چنے گئے منصوبے مطابقت میں رہتے ہیں، تاکہ آپ کہیں بھی کام مکمل نشان زد کر سکیں۔",
        "p2Lead": "یہ کیسے میپ ہوتا ہے",
        "p2Body": "Todoist کی ترجیحات نہایت اہم، زیادہ، درمیانی اور کم بن جاتی ہیں۔ ایک سطح سے گہرے ذیلی کام اپنے اصل کام کے نیچے قدموں کے طور پر دکھائے جاتے ہیں۔",
        "p3Lead": "واپس لینا آپ کے اختیار میں",
        "p3Body": "کسی بھی وقت منقطع کریں، یہاں سے یا Todoist کی ترتیبات سے۔",
        "cta": "Todoist کی طرف جاری رکھیں",
        "footnote": "Todoist آپ سے تصدیق طلب کرے گا۔"
      },
      "skip": "ابھی نہیں",
      "cancel": "منسوخ کریں",
      "waiting": "{{provider}} کا انتظار…",
      "safariWaiting": "نئے ٹیب میں مکمل کریں، پھر یہاں واپس آئیں۔",
      "safariReopen": "ٹیب دوبارہ کھولیں",
      "denied": "{{provider}} نے رسائی نہیں دی، اس لیے کچھ نہیں جوڑا گیا۔",
      "error": "{{provider}} سے رابطہ نہیں ہو سکا۔ تھوڑی دیر بعد دوبارہ کوشش کریں۔"
    },
    "detail": {
      "back_aria": "کیلنڈرز اور کام پر واپس",
      "syncNow": "ابھی مطابقت کریں",
      "intro": "منتخب کریں کہ Rhemn کیا مطابقت کرے۔ آپ اسے کسی بھی وقت بدل سکتے ہیں۔",
      "taskLists": "کام کی فہرستیں",
      "projects": "منصوبے",
      "reminders": "یاد دہانیاں",
      "calendars": "کیلنڈرز",
      "rhemnCalendarSub": "آپ کے نماز کے اوقات، مصروف شمار نہیں ہوتے",
      "loading": "لوڈ ہو رہا ہے…",
      "loadError": "آپ کی فہرستیں لوڈ نہیں ہو سکیں۔",
      "emptyGoogle": "Google Tasks میں کوئی کام کی فہرست نہیں۔",
      "emptyTodoist": "Todoist میں کوئی منصوبہ نہیں۔",
      "addError": "{{name}} شامل نہیں ہو سکا۔ دوبارہ کوشش کریں۔",
      "removed": "Rhemn سے ہٹا دیا گیا۔ یہ اب بھی {{provider}} میں موجود ہے۔",
      "undo": "کالعدم کریں",
      "prayerTimes": "اپنے کیلنڈر میں نماز کے اوقات شامل کریں",
      "prayerTimesSub": "اگلے 7 دنوں کے لیے، Rhemn نامی کیلنڈر میں پانچ نمازیں شامل کرتا ہے، تاکہ لوگ ان پر بکنگ نہ کریں۔",
      "prayerTimesOn": "فعال۔ {{date}} تک شامل کر دیا گیا۔",
      "prayerTimesWaiting": "Google کا انتظار…",
      "prayerTimesDenied": "Google نے اجازت نہیں دی۔ کچھ شامل نہیں ہوا۔",
      "prayerTimesRemoveAsk": "اپنے کیلنڈر سے Rhemn کے نماز کے اوقات ہٹا دیں؟",
      "prayerTimesKeep": "رہنے دیں",
      "prayerTimesRemove": "ہٹا دیں",
      "meetingPrompts": "میٹنگ کی یاد دہانیاں",
      "meetingPromptsSub": "جب لنک والی میٹنگ شروع ہونے والی ہو، نوٹس لینے کی پیشکش کی جائے۔",
      "busyFootnote": "میرا دن ترتیب دیں صرف یہ دیکھتا ہے کہ آپ کب مصروف ہیں، کبھی یہ نہیں کہ آپ کی میٹنگز کیا ہیں۔",
      "todoistFootnote": "Todoist کی ترجیحات نہایت اہم، زیادہ، درمیانی اور کم بن جاتی ہیں۔ ایک سطح سے گہرے ذیلی کام اپنے اصل کام کے نیچے قدموں کے طور پر دکھائے جاتے ہیں۔",
      "reauth": "{{provider}} نے Rhemn کو مطابقت کرنے دینا بند کر دیا۔ ایسا اس وقت ہوتا ہے جب رسائی ہٹا دی جائے یا آپ کا پاس ورڈ بدل جائے۔",
      "reconnect": "دوبارہ جوڑیں",
      "paused": "Rhemn Pro ختم ہونے کی وجہ سے مطابقت رکی ہوئی ہے۔ آپ کی فہرستیں ویسے ہی رہیں گی۔",
      "calendarDenied": "کیلنڈر تک رسائی بند ہے۔",
      "remindersDenied": "یاد دہانیوں تک رسائی بند ہے۔",
      "disconnect": "{{provider}} منقطع کریں",
      "disconnectTitle": "{{provider}} منقطع کریں؟",
      "disconnectBody": "{{provider}} میں کچھ حذف نہیں ہوگا۔",
      "disconnectRhemnCal": "آپ کا Rhemn نماز کے اوقات کا کیلنڈر Google Calendar سے ہٹا دیا جائے گا۔",
      "disconnectError": "{{provider}} منقطع نہیں ہو سکا۔ تھوڑی دیر بعد دوبارہ کوشش کریں۔",
      "keepLists": "میری فہرستیں Rhemn میں رکھیں",
      "keepListsSub": "ان کی مطابقت رک جاتی ہے اور یہ عام Rhemn فہرستیں بن جاتی ہیں۔",
      "removeLists": "انہیں Rhemn سے ہٹا دیں",
      "removeListsSub": "صرف Rhemn میں موجود نقول ہٹائی جاتی ہیں۔",
      "disconnecting": "منقطع ہو رہا ہے…",
      "appleStop": "کیلنڈر اور یاد دہانیاں استعمال کرنا بند کریں",
      "appleStopTitle": "کیلنڈر اور یاد دہانیاں استعمال کرنا بند کریں؟",
      "appleStopBody": "Rhemn آپ کے ایونٹس اور یاد دہانیاں دکھانا بند کر دے گا۔ رسائی مکمل طور پر ہٹانے کے لیے، اسے ترتیبات میں بند کریں۔",
      "justNow": "ابھی ابھی",
      "tasksScope": "Rhemn کو آپ کے Google Tasks دیکھنے کی اجازت درکار ہے۔ دوبارہ جوڑیں اور اجازت دینے کے لیے Tasks کو نشان زد کریں۔",
      "calendarsLoadError": "آپ کے کیلنڈرز لوڈ نہیں ہو سکے۔",
      "calendarsEmpty": "اس اکاؤنٹ میں کوئی کیلنڈر نہیں۔",
      "calendarsScope": "Rhemn کو آپ کا Google Calendar دیکھنے کی اجازت درکار ہے۔ دوبارہ جوڑیں اور اجازت کے لیے Calendar پر نشان لگائیں۔",
      "prayerTimesError": "آپ کے نماز کے اوقات شامل نہیں ہو سکے۔ کچھ دیر بعد دوبارہ کوشش کریں۔",
      "remindersEmpty": "یاد دہانیوں میں کوئی فہرست نہیں۔",
      "openSettings": "ترتیبات کھولیں",
      "appleStopCta": "استعمال بند کریں"
    },
    "locked": {
      "body": "اپنی میٹنگز اپنے نماز کے وقفوں کے اندر دیکھیں، اور Google Tasks کو Rhemn کے ساتھ مطابقت میں رکھیں۔",
      "googleName": "Google Calendar اور Tasks"
    },
    "device": {
      "phone": "iPhone",
      "pad": "iPad",
      "mac": "Mac",
      "fallback": "ڈیوائس"
    },
    "tasks": {
      "syncedWith_aria": "{{list}}، {{provider}} کے ساتھ مطابقت پذیر",
      "unlinkConfirm": "”{{name}}“ کو Rhemn سے ہٹا دیں؟ یہ {{provider}} میں موجود رہے گی۔",
      "remove": "ہٹا دیں",
      "offline": "آف لائن · آپ کے واپس آنے پر تبدیلیاں {{provider}} سے مطابقت پذیر ہو جائیں گی۔",
      "stillSyncing": "{{provider}} کے ساتھ اب بھی مطابقت جاری ہے…",
      "failed_one": "{{count}} تبدیلی {{provider}} تک نہیں پہنچی۔",
      "failed_other": "{{count}} تبدیلیاں {{provider}} تک نہیں پہنچیں۔",
      "retry": "دوبارہ کوشش کریں",
      "needsReconnect": "{{provider}} کو آپ کے دوبارہ جڑنے کی ضرورت ہے۔",
      "paused": "مطابقت رکی ہوئی ہے · Rhemn Pro ختم ہو گیا۔",
      "upgrade": "اپ گریڈ کریں",
      "notSynced": "مطابقت نہیں ہوئی",
      "notSynced_aria": "{{provider}} سے مطابقت نہیں ہوئی۔ دوبارہ کوشش کریں۔",
      "remindersOff": "Rhemn یاد دہانیاں تک نہیں پہنچ سکا۔ اسے ترتیبات میں دوبارہ آن کریں۔",
      "dueToday": "آج",
      "dueTomorrow": "کل",
      "googleTasks": "Google Tasks"
    },
    "today": {
      "allDay": "سارا دن",
      "more": "+{{count}}",
      "more_aria": "سارے دن کے مزید {{count}} ایونٹس دکھائیں",
      "less_aria": "سارے دن کے کم ایونٹس دکھائیں",
      "events_aria": "ایونٹس",
      "event_aria": "{{start}} سے {{end}} تک، {{title}}",
      "allDayEvent_aria": "سارا دن، {{title}}",
      "untitled": "مصروف",
      "now": "ابھی · {{end}} تک",
      "until": "{{end}} تک",
      "into": "· {{prayer}} تک",
      "loadError": "آپ کا کیلنڈر لوڈ نہیں ہو سکا۔",
      "needsReconnect": "Google Calendar کو آپ کے دوبارہ جڑنے کی ضرورت ہے۔",
      "scope": "Rhemn آپ کا Google Calendar نہیں دیکھ سکتا۔ دوبارہ جوڑیں اور اجازت کے لیے Calendar پر نشان لگائیں۔",
      "appleOff": "Rhemn آپ کا کیلنڈر نہیں دیکھ سکتا۔ اسے ترتیبات میں دوبارہ آن کریں۔"
    },
    "plan": {
      "mostlyMeetings": "زیادہ تر میٹنگز · {{duration}} فارغ",
      "noFreeTime": "کوئی فارغ وقت نہیں",
      "aroundMeetings_one": "{{count}} میٹنگ کے گرد ترتیب دیا گیا۔",
      "aroundMeetings_other": "{{count}} میٹنگز کے گرد ترتیب دیا گیا۔",
      "settledBusy": "سب کچھ پہلے ہی آپ کی میٹنگز کے گرد سما چکا ہے۔"
    },
    "meeting": {
      "group_aria": "میٹنگ شروع ہو رہی ہے",
      "now": "ابھی",
      "takeNotes": "نوٹس لیں",
      "takeNotes_aria": "{{title}} کے نوٹس لیں",
      "dismiss_aria": "ہٹائیں",
      "announce": "{{title}} {{when}} شروع ہو گی۔",
      "announceNow": "{{title}} ابھی شروع ہو رہی ہے۔",
      "yourMeeting": "آپ کی میٹنگ"
    },
    "apple": {
      "primer": {
        "title": "اپنا کیلنڈر اپنی نمازوں کے ساتھ دیکھیں",
        "body": "Rhemn اس {{device}} پر موجود ایونٹس اور یاد دہانیاں پڑھتا ہے تاکہ انہیں آپ کے دن میں رکھ سکے۔ یہ آپ کے آلے پر ہی رہتے ہیں۔ «میرا دن ترتیب دیں» صرف آپ کے مصروف اوقات استعمال کرتا ہے۔",
        "cta": "جاری رکھیں",
        "skip": "ابھی نہیں",
        "footnote": "{{device}} دو بار پوچھے گا، ایک بار کیلنڈر کے لیے اور ایک بار یاد دہانیوں کے لیے۔ آپ دونوں میں سے کسی کو بھی ترتیبات میں بدل سکتے ہیں۔"
      }
    }
  }
}
